var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-container"
  }, [_vm._l((_vm.downList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "data_item"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._m(0, true)])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "news_wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "news_container"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news_item"
    }, [_c('div', {
      style: ({
        'backgroundImage': 'url(' + item.img + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "item_title media_font_size_50"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item_date media_font_size_30"
    }, [_vm._v(_vm._s(item.date))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50",
    on: {
      "click": function($event) {
        return _vm.handelJump('/newsCenter?tab=0')
      }
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "co_wrap"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "swiper-container coswiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.logoList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50"
  }, [_vm._v("查看更多")])])], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/exhibitor/2025%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf",
      "target": "_blank"
    }
  }, [_vm._v("立即下载/Download")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v("广州国际车展")]), _vm._v(" "), _c('span', [_vm._v("AUTOSHOW")])]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_19_video.mp4",
      "controls": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v("展会新闻")]), _vm._v(" "), _c('span', [_vm._v("NEWS")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map_wrap"
  }, [_c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/map.png",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v("合作媒体")]), _vm._v(" "), _c('span', {
    staticClass: "mb_80"
  }, [_vm._v("MEDIA")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c690ba","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/dataDown.vue
// module id = null
// module chunks = 